// Ready-made starting templates + bilingual UI strings for the Workbench.
// Picking a template only FILLS the brief — zero credits. Credits are spent
// only when the user presses Generate Draft.

export const TEMPLATES = [
  {
    id: "school",
    icon: "School",
    en: "School / Admissions",
    te: "పాఠశాల / అడ్మిషన్లు",
    descEn: "Admissions page, courses, fees, registration form",
    descTe: "అడ్మిషన్స్ పేజీ, కోర్సులు, ఫీజులు, నమోదు ఫారం",
    brief:
      "School admissions website: hero with school name and admissions-open banner, about section, courses offered with fees, photo gallery, student registration form (name, date of birth, gender, course, parent name, mobile, email, address) with photo upload from camera or gallery, contact section with phone and WhatsApp buttons, footer with address",
  },
  {
    id: "bakery",
    icon: "Cake",
    en: "Bakery / Food",
    te: "బేకరీ / ఫుడ్",
    descEn: "Menu with prices, order form, photos",
    descTe: "ధరలతో మెనూ, ఆర్డర్ ఫారం, ఫోటోలు",
    brief:
      "Bakery website: warm hero with shop name, menu section with item photos and prices, today's specials, order form (name, mobile, items, delivery address) with photo upload support, customer reviews, contact with phone and WhatsApp order buttons, footer with timings and address",
  },
  {
    id: "business",
    icon: "Briefcase",
    en: "Business / Services",
    te: "బిజినెస్ / సేవలు",
    descEn: "Services, why-us, enquiry form",
    descTe: "సేవలు, ఎందుకు మేము, విచారణ ఫారం",
    brief:
      "Business services website: professional hero with company name and tagline, services grid with icons, why choose us section, team/about section, customer enquiry form (name, mobile, service needed, message), testimonials, contact with phone, email and WhatsApp buttons, footer",
  },
  {
    id: "clinic",
    icon: "Stethoscope",
    en: "Hospital / Clinic",
    te: "హాస్పిటల్ / క్లినిక్",
    descEn: "Doctors, timings, appointment form",
    descTe: "డాక్టర్లు, సమయాలు, అపాయింట్మెంట్ ఫారం",
    brief:
      "Clinic website: calm hero with clinic name, doctors list with specializations, treatments/services section, appointment booking form (patient name, age, mobile, problem, preferred date), timings and OP schedule, contact with phone and WhatsApp buttons, footer with address and map placeholder",
  },
  {
    id: "salon",
    icon: "Scissors",
    en: "Salon / Beauty",
    te: "సెలూన్ / బ్యూటీ",
    descEn: "Services with prices, gallery, booking",
    descTe: "ధరలతో సేవలు, గ్యాలరీ, బుకింగ్",
    brief:
      "Salon and beauty website: stylish hero, services with prices (haircut, facial, bridal packages), photo gallery, booking form (name, mobile, service, date and time), offers section, contact with phone and WhatsApp buttons, footer",
  },
  {
    id: "restaurant",
    icon: "UtensilsCrossed",
    en: "Restaurant / Hotel",
    te: "రెస్టారెంట్ / హోటల్",
    descEn: "Menu, specials, table/order form",
    descTe: "మెనూ, స్పెషల్స్, టేబుల్/ఆర్డర్ ఫారం",
    brief:
      "Restaurant website: appetizing hero, menu sections (starters, mains, desserts) with prices, today's specials, table booking or parcel order form (name, mobile, items or table size, time), reviews, contact with phone and WhatsApp buttons, footer with location and timings",
  },
  {
    id: "shop",
    icon: "ShoppingCart",
    en: "Online Store (Amazon style)",
    te: "ఆన్‌లైన్ స్టోర్ (అమెజాన్ స్టైల్)",
    descEn: "Full store: search, cart, checkout, orders",
    descTe: "పూర్తి స్టోర్: సెర్చ్, కార్ట్, చెక్అవుట్, ఆర్డర్లు",
    brief:
      "Full e-commerce online store like Amazon/Flipkart for this business: 15+ realistic products with prices in rupees and ratings, live search box, category filter chips, product grid with photos and Add to Cart, slide-in cart with quantities and grand total, checkout form (name, mobile, address, COD/UPI payment) with order-placed confirmation and WhatsApp order button, sale offer banner, footer with contact",
  },
  {
    id: "portfolio",
    icon: "Palette",
    en: "Portfolio / Personal",
    te: "పోర్ట్‌ఫోలియో / వ్యక్తిగత",
    descEn: "Skills, work gallery, contact",
    descTe: "నైపుణ్యాలు, పనుల గ్యాలరీ, కాంటాక్ట్",
    brief:
      "Personal portfolio website: hero with name and role, about section, skills with progress bars, work/project gallery with photos, contact form (name, email, message), social links, footer",
  },
  {
    id: "drawing",
    icon: "Brush",
    en: "Drawing / Photo Tool",
    te: "డ్రాయింగ్ / ఫోటో టూల్",
    descEn: "Canvas app with camera + gallery",
    descTe: "కెమెరా + గ్యాలరీతో కాన్వాస్ యాప్",
    brief:
      "Interactive drawing canvas web app: full-screen canvas, color palette, brush size and opacity sliders, eraser, undo and clear buttons, take photo with device camera onto the canvas, upload image from gallery onto the canvas, save artwork as image button, share button, smooth mobile touch drawing",
  },
  {
    id: "cybersecurity",
    icon: "ShieldCheck",
    en: "Cybersecurity Services",
    te: "సైబర్ సెక్యూరిటీ సేవలు",
    descEn: "Security services, audits, contact form",
    descTe: "సెక్యూరిటీ సేవలు, ఆడిట్లు, కాంటాక్ట్ ఫారం",
    brief:
      "Cybersecurity company website with a VERY premium futuristic AI command-center look: dark theme with electric cyan/green glow accents, animated matrix-style code rain or particle network canvas background in the hero (self-contained JS, no external libs), typing terminal intro text effect, glowing HUD stat counters (threats blocked, clients protected, audits completed) that count up when scrolled into view, a live-looking threat monitor panel with pulsing radar/scan-line animation, services grid with glowing hover cards (security audit, penetration testing/VAPT, network security, data protection, incident response, SOC monitoring), why-choose-us with certification badges, free security assessment form (name, company, mobile, email, service needed) with working validation and success state, contact with phone and WhatsApp buttons, footer. Every control must work. Premium, sharp, real-business feel — never cartoon or toy-like.",
  },
  {
    id: "cybersecurity_app",
    icon: "ShieldCheck",
    en: "Cybersecurity Service App",
    te: "సైబర్ సెక్యూరిటీ సర్వీస్ యాప్",
    descEn: "Audit booking, password checker, link scanner, threat dashboard",
    descTe: "ఆడిట్ బుకింగ్, పాస్‌వర్డ్ చెకర్, లింక్ స్కానర్, థ్రెట్ డ్యాష్‌బోర్డ్",
    brief:
      "Cybersecurity SERVICE APP (not a plain website) with a premium dark command-center look, electric cyan glow, Outfit typography, zero stock photos — pure CSS/canvas visuals only. Build these FOUR working tools, all functional with pure self-contained JavaScript: (1) LIVE THREAT DASHBOARD: pulsing radar animation, ticking feed of blocked attacks with timestamps and severity badges, animated counters. (2) AUDIT BOOKING: 'Request a Security Audit' form — name, company, 10-digit mobile, email, service dropdown (Security Audit, VAPT, Network Security, Incident Response), preferred date — with validation and a success confirmation showing a generated booking reference ID. (3) PASSWORD STRENGTH CHECKER: type a password, live strength meter (length, mixed case, digits, symbols), crack-time estimate, improvement tips. (4) PHISHING LINK SCANNER: paste a link, animated scanning progress, then a safety score out of 100 with clear reasons (https check, suspicious keywords, domain age heuristics — simulated but convincing). (5) SECURITY AUDIT QUESTIONNAIRE: 6 yes/no questions (backups, 2FA, updates, antivirus, staff training, incident plan) → on submit show a security score with grade A-F and one improvement tip per weak area. Sections: hero with the dashboard, tools grid, booking, questionnaire, contact with phone and WhatsApp buttons, footer. Smooth scroll nav. Everything must actually work.",
  },
  {
    id: "gym",
    icon: "Dumbbell",
    en: "Gym / Fitness",
    te: "జిమ్ / ఫిట్‌నెస్",
    descEn: "Plans, trainers, joining form",
    descTe: "ప్లాన్‌లు, ట్రైనర్లు, జాయినింగ్ ఫారం",
    brief:
      "Gym website: energetic hero, membership plans with prices, trainers section, facilities gallery, joining form (name, age, mobile, plan, start date), transformation photos, contact with phone and WhatsApp buttons, footer with timings",
  },
  {
    id: "academic_projects",
    icon: "GraduationCap",
    en: "Final-Year Project Topics",
    te: "ఫైనల్ ఇయర్ ప్రాజెక్ట్ టాపిక్స్",
    descEn: "ML/IoT project list with abstracts, search, filters",
    descTe: "అబ్స్ట్రాక్ట్‌లు, సెర్చ్, ఫిల్టర్లతో ప్రాజెక్ట్ జాబితా",
    brief:
      "Academic final-year project topics website (ML / deep learning / IoT / cybersecurity topics): premium hero with search bar, then 15-20 project topic CARDS — each with number, title, a real 3-4 sentence abstract (problem, approach, expected outcome), domain and tech-stack tags, difficulty level. Domain filter chips (Machine Learning, IoT, Cybersecurity, Health, Agriculture), live search, an enquiry form (name, college, mobile, topic number interested in) with validation and success state, WhatsApp contact button, footer. Cards layout, never a plain text list.",
  },
];

export const QUESTIONS = [
  {
    key: "name",
    en: "What is the name of the business or website?",
    te: "వ్యాపారం లేదా వెబ్‌సైట్ పేరు ఏమిటి?",
  },
  {
    key: "type",
    en: "What kind of business is it?",
    te: "ఇది ఏ రకమైన వ్యాపారం?",
    options: [
      { en: "School / Education", te: "పాఠశాల / విద్య" },
      { en: "Shop / Store", te: "దుకాణం" },
      { en: "Food / Restaurant", te: "ఫుడ్ / రెస్టారెంట్" },
      { en: "Clinic / Hospital", te: "క్లినిక్ / హాస్పిటల్" },
      { en: "Services / Business", te: "సేవలు / బిజినెస్" },
      { en: "Other", te: "ఇతర" },
    ],
  },
  {
    key: "offers",
    en: "What do you offer? (main services or products)",
    te: "మీరు ఏమి అందిస్తారు? (ప్రధాన సేవలు లేదా వస్తువులు)",
  },
  {
    key: "colors",
    en: "Which colors do you like for the site?",
    te: "సైట్ కోసం మీకు ఏ రంగులు ఇష్టం?",
    options: [
      { en: "Blue", te: "నీలం" },
      { en: "Green", te: "ఆకుపచ్చ" },
      { en: "Red / Maroon", te: "ఎరుపు" },
      { en: "Orange / Warm", te: "కాషాయం" },
      { en: "Purple", te: "ఊదా" },
      { en: "Black / Dark", te: "నలుపు" },
    ],
  },
  {
    key: "sections",
    en: "Which sections do you need? (tap all that apply, then Next)",
    te: "మీకు ఏ భాగాలు కావాలి? (అవసరమైనవన్నీ ఎంచుకుని Next నొక్కండి)",
    multi: true,
    options: [
      { en: "Home", te: "హోమ్" },
      { en: "About", te: "మా గురించి" },
      { en: "Services / Menu", te: "సేవలు / మెనూ" },
      { en: "Gallery / Photos", te: "గ్యాలరీ / ఫోటోలు" },
      { en: "Prices", te: "ధరలు" },
      { en: "Registration / Order Form", te: "నమోదు / ఆర్డర్ ఫారం" },
      { en: "Contact", te: "సంప్రదించండి" },
    ],
  },
  {
    key: "phone",
    en: "Phone or WhatsApp number to show on the site?",
    te: "సైట్‌లో చూపించాల్సిన ఫోన్ / వాట్సాప్ నంబర్?",
  },
  {
    key: "sitelang",
    en: "Which language should the website be in?",
    te: "వెబ్‌సైట్ ఏ భాషలో ఉండాలి?",
    options: [
      { en: "English", te: "English" },
      { en: "Telugu", te: "తెలుగు" },
      { en: "Both", te: "రెండూ" },
    ],
  },
  {
    key: "extra",
    en: "Anything special you want? (optional — or press Skip)",
    te: "ప్రత్యేకంగా ఏమైనా కావాలా? (ఐచ్ఛికం — లేదా Skip నొక్కండి)",
  },
];

export const BRIEF_STRINGS = {
  en: {
    title: "Guided questions",
    hint: "Free — no credits. I ask, you answer, I build the brief.",
    send: "Send",
    skip: "Skip",
    next: "Next",
    done: "Brief ready — press Generate Draft to create the site (uses credits)",
    use: "Use this brief",
    restart: "Start over",
    placeholder: "Type your answer…",
    langToggle: "తెలుగు",
  },
  te: {
    title: "ప్రశ్నల ద్వారా సృష్టి",
    hint: "ఉచితం — క్రెడిట్లు ఖర్చవ్వవు. నేను అడుగుతాను, మీరు సమాధానం ఇవ్వండి.",
    send: "పంపండి",
    skip: "వదిలేయండి",
    next: "తదుపరి",
    done: "వివరణ సిద్ధం — సైట్ తయారు చేయడానికి Generate Draft నొక్కండి (క్రెడిట్లు వాడబడతాయి)",
    use: "ఈ వివరణ వాడండి",
    restart: "మళ్ళీ ప్రారంభించండి",
    placeholder: "మీ సమాధానం టైప్ చేయండి…",
    langToggle: "English",
  },
};

export function composeBrief(answers) {
  const lines = [
    `Website name: ${answers.name || ""}`,
    `Business type: ${answers.type || ""}`,
    `What we offer: ${answers.offers || ""}`,
    answers.colors ? `Colors: ${answers.colors}` : null,
    answers.sections ? `Sections needed: ${answers.sections}` : null,
    answers.phone ? `Phone/WhatsApp to show: ${answers.phone}` : null,
    answers.sitelang ? `Website language: ${answers.sitelang}` : null,
    answers.extra ? `Special requirements: ${answers.extra}` : null,
    "Include working forms and buttons; where photos are useful, support camera capture and gallery upload.",
  ];
  return lines.filter(Boolean).join("\n");
}
